import fixPanelWithLogo from "../common/adaptiveFixPanel";

const GDZContainer = document.getElementById("gdz");

document.addEventListener("DOMContentLoaded", () => {
  if (GDZContainer) {
    fixPanelWithLogo(GDZContainer);
  }
});